export default __webpack_public_path__ + "static/whiteLogo-b392d8e38ca4a32aa84422c22ce11022.svg";